import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class WithdrawValidator {
  static partialWithdraw(totalAmount: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const inputValue = control.value;

      // if it's not a number - show an error
      if (!(typeof inputValue === 'number' && !Number.isNaN(inputValue))) {
        return { invalidNumber: true };
      }

      // if the amount is equal or exceeds
      if (inputValue >= Number(totalAmount.toFixed(0))) {
        return { exceeds: true };
      }

      return null;
    };
  }

  static customIbanCheck(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const iban: undefined | null | string = control.value;

      if (!iban) {
        return null;
      }
      // only uppercase letters and number
      return /^[A-Z0-9]+$/.test(iban) ? this.validateIban(iban) : { wrongIban: true };
    };
  }

  private static validateIban(iban: string) {
    return iban.length > 15 && iban.length < 35 ? null : { wrongIban: true };
  }
}
